import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from 'src/app/common/constant';
import { AuthService } from 'src/app/authorization/auth.service';
import { UserService } from 'src/app/common/service/user.service';
import { DataService } from 'src/app/common/service/data.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Dispatcher, StoreInfoUser } from 'src/app/state';
import { UserProfile } from 'src/app/common/models/users.model';
declare let $: any;
@Injectable({ providedIn: 'root' })
export class  AccountService  {
    constructor(
        private http: HttpClient,
        private router: Router,
        private dispatcher: Dispatcher,
        private authService: AuthService,
        private dataService: DataService,
        private userService: UserService) {
    }
    getInfo() {
        return {
            isAdmin: true
        }
    }
    countRegisterTrade() {
        return this.http.get(environment.urlBackEnd + Constant.api_count_list_register_trade);
    }
    logout() {
        this.clearLocal();
        this.goToLogin();
    }
    goToLogin() {
        $(document.body).removeClass("modal-open");
        $(document.body).css('padding-right','0');
        
        localStorage.setItem(Constant.key_local_login_sucess, "false");
        //Go to screen login
        this.router.navigate([Constant.url_login]);
        
    };
    clearLocal() {
        //Remove token when logout success
        this.dataService.token = null;
        this.dispatcher.fire(new StoreInfoUser({}));
        this.userService.user = new UserProfile();
        sessionStorage.removeItem(Constant.key_local_token);
        localStorage.removeItem(Constant.key_local_token);
        this.authService.clear();
    }
}
